import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StoreLocation from './components/StoreLocation';
import PrivacyPolicy from './components/PrivacyPolicy';
import ScrollToTop from './components/ScrollToTop';
import {
  WhyUs, Services, LocationBanner,
  AskUs, Expertise, WABanner, Footer, WAFloat,
} from './components/Sections';

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={
          <main>
            <Hero />
            <WhyUs />
            <Services />
            <LocationBanner />
            <AskUs />
            <Expertise />
            <WABanner />
            <StoreLocation />
          </main>
        } />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
      <WAFloat />
    </BrowserRouter>
  );
}